import { borderRadiusM, fontSizeS, spacingS } from "@rhumbix/rmbx_design_system_design_tokens";
import React, { useState } from "react";
import styled from "styled-components";
import { destructiveButtonStyles, disabledButtonStyles, selectionButtonStyles } from "../../constants";
import { getBoldFixStyles } from "../../utils";
import Copy from "../Copy";
const ActionBarButton = ({ text, theme, renderIcon, ...htmlProps }) => {
    const buttonTheme = theme ?? "default";
    const { disabled } = htmlProps;
    const [hovered, setHovered] = useState(false);
    const [pressed, setPressed] = useState(false);
    const buttonStyles = buttonTheme === "destructive" ? destructiveButtonStyles : selectionButtonStyles;
    const styleProps = pressed
        ? buttonStyles.pressed
        : hovered
            ? disabled
                ? disabledButtonStyles.hovered
                : buttonStyles.hovered
            : disabled
                ? disabledButtonStyles.default
                : buttonStyles.default;
    const { iconColor } = styleProps;
    return (React.createElement(Button, { ...styleProps, ...htmlProps, text: text, onMouseOver: () => setHovered(true), onMouseOut: () => {
            setHovered(false);
            setPressed(false);
        }, onMouseDown: () => setPressed(true), onMouseUp: () => setPressed(false) },
        React.createElement("div", { className: "content" },
            renderIcon != null && renderIcon(iconColor),
            text != null && renderIcon != null && React.createElement("span", { className: "spacer" }),
            text != null && React.createElement(Copy, { className: "text" }, text))));
};
const Button = styled.button `
    background-color: ${props => props.bgColor};
    border-radius: ${borderRadiusM};
    border: none;
    font-size: ${fontSizeS};
    padding: ${spacingS};
    transition: all 100ms;
    white-space: nowrap;

    &:hover {
        cursor: ${props => (props.disabled ? "default" : "pointer")};
    }

    .content {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .spacer {
        width: ${spacingS};
    }

    .text {
        color: ${props => props.textColor};
        font-weight: ${props => props.fontWeight};

        ::after {
            ${props => getBoldFixStyles(props.text ?? "")}
        }
    }
`;
export default ActionBarButton;
